export default __webpack_public_path__ + "static/media/pricing-lines-bottom.9d6c78b8.svg";